var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-layout"},[_c('navbar'),_c('div',{staticClass:"position-relative app-wrapper"},[_c('child')],1),_c('menuLateral')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }